// source: finxai_user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var itrdrmsgs_pb = require('./itrdrmsgs_pb.js');
goog.object.extend(proto, itrdrmsgs_pb);
goog.exportSymbol('proto.finxai_web.msg_subscription_type', null, global);
goog.exportSymbol('proto.finxai_web.user_credentials', null, global);
goog.exportSymbol('proto.finxai_web.user_information', null, global);
goog.exportSymbol('proto.finxai_web.user_login_request', null, global);
goog.exportSymbol('proto.finxai_web.user_login_response', null, global);
goog.exportSymbol('proto.finxai_web.user_login_session', null, global);
goog.exportSymbol('proto.finxai_web.user_login_session.client_access_type_enum', null, global);
goog.exportSymbol('proto.finxai_web.user_login_session.client_type_enum', null, global);
goog.exportSymbol('proto.finxai_web.user_logout_request', null, global);
goog.exportSymbol('proto.finxai_web.user_subscription_request', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.finxai_web.user_login_request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.finxai_web.user_login_request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.finxai_web.user_login_request.displayName = 'proto.finxai_web.user_login_request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.finxai_web.user_logout_request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.finxai_web.user_logout_request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.finxai_web.user_logout_request.displayName = 'proto.finxai_web.user_logout_request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.finxai_web.user_login_response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.finxai_web.user_login_response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.finxai_web.user_login_response.displayName = 'proto.finxai_web.user_login_response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.finxai_web.user_information = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.finxai_web.user_information, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.finxai_web.user_information.displayName = 'proto.finxai_web.user_information';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.finxai_web.user_credentials = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.finxai_web.user_credentials.repeatedFields_, null);
};
goog.inherits(proto.finxai_web.user_credentials, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.finxai_web.user_credentials.displayName = 'proto.finxai_web.user_credentials';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.finxai_web.user_subscription_request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.finxai_web.user_subscription_request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.finxai_web.user_subscription_request.displayName = 'proto.finxai_web.user_subscription_request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.finxai_web.user_login_session = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.finxai_web.user_login_session, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.finxai_web.user_login_session.displayName = 'proto.finxai_web.user_login_session';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.finxai_web.user_login_request.prototype.toObject = function(opt_includeInstance) {
  return proto.finxai_web.user_login_request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.finxai_web.user_login_request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_login_request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    passwd: jspb.Message.getFieldWithDefault(msg, 2, ""),
    env: jspb.Message.getFieldWithDefault(msg, 3, ""),
    newPasswd: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.finxai_web.user_login_request}
 */
proto.finxai_web.user_login_request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.finxai_web.user_login_request;
  return proto.finxai_web.user_login_request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.finxai_web.user_login_request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.finxai_web.user_login_request}
 */
proto.finxai_web.user_login_request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPasswd(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnv(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPasswd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.finxai_web.user_login_request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.finxai_web.user_login_request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.finxai_web.user_login_request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_login_request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPasswd();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnv();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNewPasswd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.finxai_web.user_login_request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_request} returns this
 */
proto.finxai_web.user_login_request.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string passwd = 2;
 * @return {string}
 */
proto.finxai_web.user_login_request.prototype.getPasswd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_request} returns this
 */
proto.finxai_web.user_login_request.prototype.setPasswd = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string env = 3;
 * @return {string}
 */
proto.finxai_web.user_login_request.prototype.getEnv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_request} returns this
 */
proto.finxai_web.user_login_request.prototype.setEnv = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string new_passwd = 4;
 * @return {string}
 */
proto.finxai_web.user_login_request.prototype.getNewPasswd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_request} returns this
 */
proto.finxai_web.user_login_request.prototype.setNewPasswd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.finxai_web.user_logout_request.prototype.toObject = function(opt_includeInstance) {
  return proto.finxai_web.user_logout_request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.finxai_web.user_logout_request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_logout_request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sessionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.finxai_web.user_logout_request}
 */
proto.finxai_web.user_logout_request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.finxai_web.user_logout_request;
  return proto.finxai_web.user_logout_request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.finxai_web.user_logout_request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.finxai_web.user_logout_request}
 */
proto.finxai_web.user_logout_request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.finxai_web.user_logout_request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.finxai_web.user_logout_request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.finxai_web.user_logout_request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_logout_request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.finxai_web.user_logout_request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_logout_request} returns this
 */
proto.finxai_web.user_logout_request.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string session_id = 2;
 * @return {string}
 */
proto.finxai_web.user_logout_request.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_logout_request} returns this
 */
proto.finxai_web.user_logout_request.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.finxai_web.user_login_response.prototype.toObject = function(opt_includeInstance) {
  return proto.finxai_web.user_login_response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.finxai_web.user_login_response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_login_response.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sessionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isLoggedin: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    loginRespMsg: jspb.Message.getFieldWithDefault(msg, 4, ""),
    userPreferences: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usrCredentials: (f = msg.getUsrCredentials()) && proto.finxai_web.user_credentials.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.finxai_web.user_login_response}
 */
proto.finxai_web.user_login_response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.finxai_web.user_login_response;
  return proto.finxai_web.user_login_response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.finxai_web.user_login_response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.finxai_web.user_login_response}
 */
proto.finxai_web.user_login_response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLoggedin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginRespMsg(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPreferences(value);
      break;
    case 6:
      var value = new proto.finxai_web.user_credentials;
      reader.readMessage(value,proto.finxai_web.user_credentials.deserializeBinaryFromReader);
      msg.setUsrCredentials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.finxai_web.user_login_response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.finxai_web.user_login_response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.finxai_web.user_login_response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_login_response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsLoggedin();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getLoginRespMsg();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserPreferences();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsrCredentials();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.finxai_web.user_credentials.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.finxai_web.user_login_response.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_response} returns this
 */
proto.finxai_web.user_login_response.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string session_id = 2;
 * @return {string}
 */
proto.finxai_web.user_login_response.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_response} returns this
 */
proto.finxai_web.user_login_response.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_loggedin = 3;
 * @return {boolean}
 */
proto.finxai_web.user_login_response.prototype.getIsLoggedin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.finxai_web.user_login_response} returns this
 */
proto.finxai_web.user_login_response.prototype.setIsLoggedin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string login_resp_msg = 4;
 * @return {string}
 */
proto.finxai_web.user_login_response.prototype.getLoginRespMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_response} returns this
 */
proto.finxai_web.user_login_response.prototype.setLoginRespMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string user_preferences = 5;
 * @return {string}
 */
proto.finxai_web.user_login_response.prototype.getUserPreferences = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_response} returns this
 */
proto.finxai_web.user_login_response.prototype.setUserPreferences = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional user_credentials usr_credentials = 6;
 * @return {?proto.finxai_web.user_credentials}
 */
proto.finxai_web.user_login_response.prototype.getUsrCredentials = function() {
  return /** @type{?proto.finxai_web.user_credentials} */ (
    jspb.Message.getWrapperField(this, proto.finxai_web.user_credentials, 6));
};


/**
 * @param {?proto.finxai_web.user_credentials|undefined} value
 * @return {!proto.finxai_web.user_login_response} returns this
*/
proto.finxai_web.user_login_response.prototype.setUsrCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.finxai_web.user_login_response} returns this
 */
proto.finxai_web.user_login_response.prototype.clearUsrCredentials = function() {
  return this.setUsrCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.finxai_web.user_login_response.prototype.hasUsrCredentials = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.finxai_web.user_information.prototype.toObject = function(opt_includeInstance) {
  return proto.finxai_web.user_information.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.finxai_web.user_information} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_information.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.finxai_web.user_information}
 */
proto.finxai_web.user_information.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.finxai_web.user_information;
  return proto.finxai_web.user_information.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.finxai_web.user_information} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.finxai_web.user_information}
 */
proto.finxai_web.user_information.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.finxai_web.user_information.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.finxai_web.user_information.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.finxai_web.user_information} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_information.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.finxai_web.user_information.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_information} returns this
 */
proto.finxai_web.user_information.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.finxai_web.user_information.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_information} returns this
 */
proto.finxai_web.user_information.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last_name = 3;
 * @return {string}
 */
proto.finxai_web.user_information.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_information} returns this
 */
proto.finxai_web.user_information.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone_number = 4;
 * @return {string}
 */
proto.finxai_web.user_information.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_information} returns this
 */
proto.finxai_web.user_information.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string email = 5;
 * @return {string}
 */
proto.finxai_web.user_information.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_information} returns this
 */
proto.finxai_web.user_information.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.finxai_web.user_credentials.repeatedFields_ = [5,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.finxai_web.user_credentials.prototype.toObject = function(opt_includeInstance) {
  return proto.finxai_web.user_credentials.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.finxai_web.user_credentials} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_credentials.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sessionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    role: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isLoggedin: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    accountsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    groupsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    teamsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    appLayout: jspb.Message.getFieldWithDefault(msg, 8, ""),
    credentials: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userInfo: (f = msg.getUserInfo()) && proto.finxai_web.user_information.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.finxai_web.user_credentials}
 */
proto.finxai_web.user_credentials.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.finxai_web.user_credentials;
  return proto.finxai_web.user_credentials.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.finxai_web.user_credentials} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.finxai_web.user_credentials}
 */
proto.finxai_web.user_credentials.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLoggedin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccounts(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroups(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addTeams(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppLayout(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCredentials(value);
      break;
    case 10:
      var value = new proto.finxai_web.user_information;
      reader.readMessage(value,proto.finxai_web.user_information.deserializeBinaryFromReader);
      msg.setUserInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.finxai_web.user_credentials.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.finxai_web.user_credentials.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.finxai_web.user_credentials} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_credentials.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsLoggedin();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getTeamsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getAppLayout();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCredentials();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserInfo();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.finxai_web.user_information.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.finxai_web.user_credentials.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string session_id = 2;
 * @return {string}
 */
proto.finxai_web.user_credentials.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string role = 3;
 * @return {string}
 */
proto.finxai_web.user_credentials.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_loggedin = 4;
 * @return {boolean}
 */
proto.finxai_web.user_credentials.prototype.getIsLoggedin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setIsLoggedin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated string accounts = 5;
 * @return {!Array<string>}
 */
proto.finxai_web.user_credentials.prototype.getAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setAccountsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.addAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * repeated string groups = 6;
 * @return {!Array<string>}
 */
proto.finxai_web.user_credentials.prototype.getGroupsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setGroupsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.addGroups = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * repeated string teams = 7;
 * @return {!Array<string>}
 */
proto.finxai_web.user_credentials.prototype.getTeamsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setTeamsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.addTeams = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.clearTeamsList = function() {
  return this.setTeamsList([]);
};


/**
 * optional string app_layout = 8;
 * @return {string}
 */
proto.finxai_web.user_credentials.prototype.getAppLayout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setAppLayout = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string credentials = 9;
 * @return {string}
 */
proto.finxai_web.user_credentials.prototype.getCredentials = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.setCredentials = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional user_information user_info = 10;
 * @return {?proto.finxai_web.user_information}
 */
proto.finxai_web.user_credentials.prototype.getUserInfo = function() {
  return /** @type{?proto.finxai_web.user_information} */ (
    jspb.Message.getWrapperField(this, proto.finxai_web.user_information, 10));
};


/**
 * @param {?proto.finxai_web.user_information|undefined} value
 * @return {!proto.finxai_web.user_credentials} returns this
*/
proto.finxai_web.user_credentials.prototype.setUserInfo = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.finxai_web.user_credentials} returns this
 */
proto.finxai_web.user_credentials.prototype.clearUserInfo = function() {
  return this.setUserInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.finxai_web.user_credentials.prototype.hasUserInfo = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.finxai_web.user_subscription_request.prototype.toObject = function(opt_includeInstance) {
  return proto.finxai_web.user_subscription_request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.finxai_web.user_subscription_request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_subscription_request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sessionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subscriptionType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.finxai_web.user_subscription_request}
 */
proto.finxai_web.user_subscription_request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.finxai_web.user_subscription_request;
  return proto.finxai_web.user_subscription_request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.finxai_web.user_subscription_request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.finxai_web.user_subscription_request}
 */
proto.finxai_web.user_subscription_request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 3:
      var value = /** @type {!proto.finxai_web.msg_subscription_type} */ (reader.readEnum());
      msg.setSubscriptionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.finxai_web.user_subscription_request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.finxai_web.user_subscription_request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.finxai_web.user_subscription_request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_subscription_request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.finxai_web.user_subscription_request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_subscription_request} returns this
 */
proto.finxai_web.user_subscription_request.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string session_id = 2;
 * @return {string}
 */
proto.finxai_web.user_subscription_request.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_subscription_request} returns this
 */
proto.finxai_web.user_subscription_request.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional msg_subscription_type subscription_type = 3;
 * @return {!proto.finxai_web.msg_subscription_type}
 */
proto.finxai_web.user_subscription_request.prototype.getSubscriptionType = function() {
  return /** @type {!proto.finxai_web.msg_subscription_type} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.finxai_web.msg_subscription_type} value
 * @return {!proto.finxai_web.user_subscription_request} returns this
 */
proto.finxai_web.user_subscription_request.prototype.setSubscriptionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.finxai_web.user_login_session.prototype.toObject = function(opt_includeInstance) {
  return proto.finxai_web.user_login_session.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.finxai_web.user_login_session} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_login_session.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    creds: (f = msg.getCreds()) && proto.finxai_web.user_credentials.toObject(includeInstance, f),
    hasActiveSession: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    sessionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sessionHost: jspb.Message.getFieldWithDefault(msg, 5, ""),
    clientType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    clientAccessType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    loginTime: (f = msg.getLoginTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    logoutTime: (f = msg.getLogoutTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastUpdTimestamp: (f = msg.getLastUpdTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.finxai_web.user_login_session}
 */
proto.finxai_web.user_login_session.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.finxai_web.user_login_session;
  return proto.finxai_web.user_login_session.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.finxai_web.user_login_session} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.finxai_web.user_login_session}
 */
proto.finxai_web.user_login_session.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.finxai_web.user_credentials;
      reader.readMessage(value,proto.finxai_web.user_credentials.deserializeBinaryFromReader);
      msg.setCreds(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasActiveSession(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionHost(value);
      break;
    case 6:
      var value = /** @type {!proto.finxai_web.user_login_session.client_type_enum} */ (reader.readEnum());
      msg.setClientType(value);
      break;
    case 7:
      var value = /** @type {!proto.finxai_web.user_login_session.client_access_type_enum} */ (reader.readEnum());
      msg.setClientAccessType(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLoginTime(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLogoutTime(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.finxai_web.user_login_session.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.finxai_web.user_login_session.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.finxai_web.user_login_session} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.finxai_web.user_login_session.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreds();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.finxai_web.user_credentials.serializeBinaryToWriter
    );
  }
  f = message.getHasActiveSession();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSessionHost();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClientType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getClientAccessType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getLoginTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLogoutTime();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastUpdTimestamp();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.finxai_web.user_login_session.client_type_enum = {
  WEB: 0,
  DESKTOP: 1,
  CLI: 2,
  DATABASE: 3
};

/**
 * @enum {number}
 */
proto.finxai_web.user_login_session.client_access_type_enum = {
  READ_ONLY: 0,
  READ_WRITE: 1,
  ADMIN: 2,
  SUPPORT: 3
};

/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.finxai_web.user_login_session.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional user_credentials creds = 2;
 * @return {?proto.finxai_web.user_credentials}
 */
proto.finxai_web.user_login_session.prototype.getCreds = function() {
  return /** @type{?proto.finxai_web.user_credentials} */ (
    jspb.Message.getWrapperField(this, proto.finxai_web.user_credentials, 2));
};


/**
 * @param {?proto.finxai_web.user_credentials|undefined} value
 * @return {!proto.finxai_web.user_login_session} returns this
*/
proto.finxai_web.user_login_session.prototype.setCreds = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.clearCreds = function() {
  return this.setCreds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.finxai_web.user_login_session.prototype.hasCreds = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool has_active_session = 3;
 * @return {boolean}
 */
proto.finxai_web.user_login_session.prototype.getHasActiveSession = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.setHasActiveSession = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string session_id = 4;
 * @return {string}
 */
proto.finxai_web.user_login_session.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string session_host = 5;
 * @return {string}
 */
proto.finxai_web.user_login_session.prototype.getSessionHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.setSessionHost = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional client_type_enum client_type = 6;
 * @return {!proto.finxai_web.user_login_session.client_type_enum}
 */
proto.finxai_web.user_login_session.prototype.getClientType = function() {
  return /** @type {!proto.finxai_web.user_login_session.client_type_enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.finxai_web.user_login_session.client_type_enum} value
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.setClientType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional client_access_type_enum client_access_type = 7;
 * @return {!proto.finxai_web.user_login_session.client_access_type_enum}
 */
proto.finxai_web.user_login_session.prototype.getClientAccessType = function() {
  return /** @type {!proto.finxai_web.user_login_session.client_access_type_enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.finxai_web.user_login_session.client_access_type_enum} value
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.setClientAccessType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp login_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.finxai_web.user_login_session.prototype.getLoginTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.finxai_web.user_login_session} returns this
*/
proto.finxai_web.user_login_session.prototype.setLoginTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.clearLoginTime = function() {
  return this.setLoginTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.finxai_web.user_login_session.prototype.hasLoginTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp logout_time = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.finxai_web.user_login_session.prototype.getLogoutTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.finxai_web.user_login_session} returns this
*/
proto.finxai_web.user_login_session.prototype.setLogoutTime = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.clearLogoutTime = function() {
  return this.setLogoutTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.finxai_web.user_login_session.prototype.hasLogoutTime = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp last_upd_timestamp = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.finxai_web.user_login_session.prototype.getLastUpdTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.finxai_web.user_login_session} returns this
*/
proto.finxai_web.user_login_session.prototype.setLastUpdTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.finxai_web.user_login_session} returns this
 */
proto.finxai_web.user_login_session.prototype.clearLastUpdTimestamp = function() {
  return this.setLastUpdTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.finxai_web.user_login_session.prototype.hasLastUpdTimestamp = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * @enum {number}
 */
proto.finxai_web.msg_subscription_type = {
  NONE: 0,
  MSG_SUBSCRIBE: 1,
  MSG_UNSUBSCRIBE: 2
};

goog.object.extend(exports, proto.finxai_web);
